import {
  useDispatch
} from 'react-redux'
import { useEffect, useState } from 'react'
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

let fromLocalStorage1 = false, company1 = ''

const readStoredValue = key => {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (error) {
    return null
  }
}

const getCompanyCodeFromSearch = search => {
  const params = new URLSearchParams((search || '').replace(/^\?/, ''))
  const namedCompany = params.get('company') || params.get('client') || params.get('tenant')
  if (namedCompany) return namedCompany.trim()

  const knownKeys = ['ref', 'referral', 'campaign', 'promo', 'discount', 'discountCode', 'bookingId']
  const legacyCompany = Array.from(params.entries())
    .find(([key, value]) => key && value === '' && !knownKeys.includes(key))?.[0]
  return legacyCompany?.trim() || 'UKCB'
}

const SpinnerComponent = () => {
  const dispatch = useDispatch()
  const [logo, setLogo] = useState(require('@src/assets/images/logo/Loading-Logo.png').default)

  const getAllData = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

    const response = await axios.post('https://api.zasway.com:8443/Booking/GetCompanyDetails', params, { mode: 'cors' })
  
    return response.data
  })
  const getLogo = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

    const response = await axios.post('https://api.zasway.com:8443/Common/GetSystemLogo', params, { mode: 'cors' })
  
    return response.data
  })
  
  const GetCompanyDetails = async () => {
    try {
      const storedCompanyID = Number(readStoredValue('companyID')) || 0
      const isWebBooker = window.location?.pathname?.toLowerCase().includes('webbooker')
      const fromLocalStorage = !isWebBooker && storedCompanyID > 0
      let companyID = fromLocalStorage ? storedCompanyID : 0
      let system = readStoredValue('staffRoleID') || 'Admin'

      fromLocalStorage1 = fromLocalStorage
      if (!fromLocalStorage) {
        let shortName = getCompanyCodeFromSearch(window.location?.search)
        if (shortName.includes('PassApp')) {
          system = 'Passenger'
          shortName = shortName.split('_PassApp')[0]
        }

        const response = await dispatch(getAllData({ companyShortName: shortName }))
        const company = response?.payload
        company1 = company || ''
        companyID = Number(company?.id) || 0
      }

      if (!companyID) return

      const response = await dispatch(getLogo({ userType: system, companyID }))
      if (response.payload) {
        const logoPath = response.payload.navBarLogo ? require(`@src/assets/images/logo/${response.payload.mainLogo}`).default : require('@src/assets/images/logo/Loading-Logo.png').default
        setLogo(logoPath)
      }
    } catch (error) {
      console.error('Unable to load spinner company details:', error)
    }
  }
 useEffect(() => {
  const queryPart = window?.location?.href?.split('?')[1]
    const keyBeforeColon = queryPart?.split(':')[0]
    if (keyBeforeColon !== "success" && keyBeforeColon !== "error") {

 GetCompanyDetails()
  }
  }, [])
   
  console.log(fromLocalStorage1, company1)
  return (
    // fromLocalStorage1 === true && parseJSON(localStorage.getItem('companyID')) === 1 ? (
    //   <div className='fallback-spinner app-loader'>
    //     <img className='fallback-logo' src={logo} alt='logo' />
    //     <div className='loading'>
    //       <div className='effect-1 effects'></div>
    //       <div className='effect-2 effects'></div>
    //       <div className='effect-3 effects'></div>
    //     </div>
    //   </div>
    // ) : (fromLocalStorage1 === false && company1.id === 1 ? (
    //   <div className='fallback-spinner app-loader'>
    //     <img className='fallback-logo' src={logo} alt='logo' />
    //     <div className='loading'>
    //       <div className='effect-1 effects'></div>
    //       <div className='effect-2 effects'></div>
    //       <div className='effect-3 effects'></div>
    //     </div>
    //   </div>
    // ) : <div className='chariot-fallback-spinner chariot-app-loader'>
    //     <img className='fallback-logo' src={logo} alt='logo' />
    //     <div className='loading'>
    //       <div className='effect-1 effects'></div>
    //       <div className='effect-2 effects'></div>
    //       <div className='effect-3 effects'></div>
    //     </div>
    //   </div>
    // )
    window.location?.search !== "" && window.location?.search?.split("?") !== undefined && window.location?.search?.split("?")[1] !== undefined) ? (

     window.location?.search?.split("?")[1] === 'DE_PassApp' || window.location?.pathname?.includes('DE_PassApp') || (JSON.parse(localStorage.getItem('companyID')) === 10010 && JSON.parse(localStorage.getItem('staffRoleID')) === 'Passenger') ? (
    <div className='de-fallback-spinner de-app-loader'>
    <div className='loading'>
      <div className='effect-1 effects'></div>
      <div className='effect-2 effects'></div>
      <div className='effect-3 effects'></div>
    </div>
  </div>
  ) : window.location?.search?.split("?")[1] === 'CharChauf' ||  window.location?.search?.split("?")[1] === 'CharChauf_PassApp' || JSON.parse(localStorage.getItem('companyID')) === 10005 ? (
   
         
    <div className='chariot-fallback-spinner chariot-app-loader'>
    <img className='fallback-logo' src={logo} alt='logo' />
    <div className='loading'>
      <div className='effect-1 effects'></div>
      <div className='effect-2 effects'></div>
      <div className='effect-3 effects'></div>
    </div>
  </div>) : (<div className='fallback-spinner app-loader'>
          <img className='fallback-logo' src={logo} alt='logo' />
          <div className='loading'>
            <div className='effect-1 effects'></div>
            <div className='effect-2 effects'></div>
            <div className='effect-3 effects'></div>
          </div>
        </div>)
  ) : (JSON.parse(localStorage.getItem('companyID')) === 10010 && JSON.parse(localStorage.getItem('staffRoleID')) === 'Passenger' ? (
    <div className='de-fallback-spinner de-app-loader'>
    <div className='loading'>
      <div className='effect-1 effects'></div>
      <div className='effect-2 effects'></div>
      <div className='effect-3 effects'></div>
    </div>
  </div>
  ) : JSON.parse(localStorage.getItem('companyID')) === 10005 ? (
    <div className='chariot-fallback-spinner chariot-app-loader'>
    <img className='fallback-logo' src={logo} alt='logo' />
    <div className='loading'>
      <div className='effect-1 effects'></div>
      <div className='effect-2 effects'></div>
      <div className='effect-3 effects'></div>
    </div>
  </div>) : (
   
   <div className='fallback-spinner app-loader'>
   <img className='fallback-logo' src={logo} alt='logo' />
   <div className='loading'>
     <div className='effect-1 effects'></div>
     <div className='effect-2 effects'></div>
     <div className='effect-3 effects'></div>
   </div>
 </div>))
}

export default SpinnerComponent
